import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';

const ITEM_HEIGHT = 48;


const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    PaperProps={{
        style: {
            maxHeight: ITEM_HEIGHT * 7.5,
            width: '21ch',
        }
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const ColumnDeselector = ({ options, selected, setSelected }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setSelectedHandle = (e) => {
    const selectedValue = e.target.value
    const newSelection = selected.filter((x) => x !== selectedValue)
    if (!selected.includes(selectedValue)) {
        newSelection.push(selectedValue)
    }
    setSelected(newSelection)
    localStorage.setItem('enduringpromises.com.bookingsbyprice.selected', newSelection);
  }

  const handleClear = () => {
    setSelected([]);
    localStorage.setItem('enduringpromises.com.bookingsbyprice.selected', []);
  }

  return (
    <div>
      <Tooltip title="Hide columns">
        <IconButton
            aria-controls="column-deselector-menu"
            aria-haspopup="true"
            variant="contained"
            onClick={handleClick}
        >
            <ListIcon />
        </IconButton>
      </Tooltip>
      <StyledMenu
        id="column-deselector-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option) => (
          <StyledMenuItem key={option} selected={Boolean(selected.find((x) => x === option))} onClick={setSelectedHandle} value={option}>
            {option}
          </StyledMenuItem>
        ))}
        <Divider />
        <StyledMenuItem onClick={handleClear}>
            <Button
                variant="outlined"
            >
                Reset Selection
            </Button>
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
}

export default ColumnDeselector;